import {
  registerBottomSheets,
  BottomSheetComponent,
} from '@bonanza-social/navigation';

import GeoFenceBottomSheet from './GeoFenceBottomSheet';

const bottomSheets = {
  default: GeoFenceBottomSheet,
};

registerBottomSheets('geoFence', bottomSheets);

declare global {
  interface RegisteredBottomSheets {
    geoFence: Record<keyof typeof bottomSheets, BottomSheetComponent>;
  }
}
